// extracted by mini-css-extract-plugin
export default {"htmlContent":"EpboEp","description":"mIlVIq","content":"zddDMd","descriptionWrapper":"QKOt7f","title":"YD6UhV","contentWrapper":"ZXXP8H","showMoreOrLess":"LtTzIt"};